module.exports = __webpack_public_path__ + "img/sample-room-1.68e2a855.png";